/* @babel ES2025 */

import Plugin		from "plugin";


export default class MyPlugin extends Plugin {
  static clientpath = "plugins/plugin-authenticate.js"
    
  constructor(...args) {
    super(...args);    
  }
}